import React from "react";

const DragSectionIcon = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M20.75 8H3.25C2.5625 8 2 8.6 2 9.33333C2 10.0667 2.5625 10.6667 3.25 10.6667H20.75C21.4375 10.6667 22 10.0667 22 9.33333C22 8.6 21.4375 8 20.75 8ZM3.25 16H20.75C21.4375 16 22 15.4 22 14.6667C22 13.9333 21.4375 13.3333 20.75 13.3333H3.25C2.5625 13.3333 2 13.9333 2 14.6667C2 15.4 2.5625 16 3.25 16Z"
				fill="#789B73"
			/>
		</svg>
	);
};

export default DragSectionIcon;
